<ng-container *ngIf="events.length">
  <div class="head">
    <h2>{{ 'events' | translate }}</h2>
    <div class="arrows" *ngIf="canBack || canForward">
      <button [disabled]="!canBack" (click)="scroll(-1)" aria-label="←">
        <svg viewBox="0 0 24 24" width="18" height="18"><path d="m14 6-6 6 6 6" /></svg>
      </button>
      <button [disabled]="!canForward" (click)="scroll(1)" aria-label="→">
        <svg viewBox="0 0 24 24" width="18" height="18"><path d="m10 6 6 6-6 6" /></svg>
      </button>
    </div>
  </div>

  <div class="strip" #strip (scroll)="updateArrows()">
    <figure class="poster" *ngFor="let event of events" (click)="opened = event">
      <img [src]="event.image || event.thumbImage" alt="" loading="lazy" />
      <!-- Подписи скрыты: у событий пока нет переводов (ROADMAP 3b, «События: текст и языки») -->
      <!-- <figcaption *ngIf="event.description">{{ event.description }}</figcaption> -->
    </figure>
  </div>
</ng-container>

<div class="fullscreen" *ngIf="opened" (click)="closePoster()">
  <img [src]="opened.image || opened.thumbImage" alt="" />
</div>
